module.exports = __webpack_public_path__ + "static/img/2.d4e657c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/2.jpg
// module id = KuKr
// module chunks = 21